import { getAPI } from '../utils/api';
import endpoints from '../utils/endpoints';

export const normalizeSupportQueriesResponse = (response) => {
  const body = response?.data ?? response;
  const payload = body?.data ?? body;

  return {
    content: Array.isArray(payload?.content) ? payload.content : [],
    totalElements: payload?.totalElements ?? 0,
    totalPages: payload?.totalPages ?? 0,
    number: payload?.number ?? 0,
    size: payload?.size ?? 0,
    first: payload?.first ?? true,
    last: payload?.last ?? true,
  };
};

export const getAllSupportQueries = (payload, callBack, errorCallback) => {
  return (dispatch) => {
    const queryParams = {
      page: payload?.page ?? 0,
      size: payload?.size ?? payload?.perPage ?? 20,
    };

    getAPI(
      endpoints.HELP_SUPPORT_QUERIES,
      queryParams,
      (response) => {
        callBack(normalizeSupportQueriesResponse(response));
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};
